export const getLoggedUser = () => {
  return localStorage.getItem("loggedUser");
};

export const logoutUser = () => {
  localStorage.removeItem("loggedUser");
};
